import {
  applyConfirmPlacement,
  applyDrawDraftOptions,
  applyPickDraftToken,
  applySyncViewerState,
} from "./appliers";
import type { KingsCrownAction, KingsCrownState } from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: KingsCrownState,
  action: KingsCrownAction,
): KingsCrownState {
  if (state.completedActionIds.includes(action.actionId)) {
    return state;
  }
  if (!validateAction(state, action).valid) {
    return state;
  }

  switch (action.type) {
    case "DrawDraftOptions":
      return applyDrawDraftOptions(state, action);
    case "PickDraftToken":
      return applyPickDraftToken(state, action);
    case "ConfirmPlacement":
      return applyConfirmPlacement(state, action);
    case "SyncViewerState":
      return applySyncViewerState(state, action);
  }
}
